export enum ERROR_RESPONSE_MESSAGES {
  WRONG_AUTH_CODE = 'WRONG_AUTH_CODE',
  REQUEST_COMPLETED = 'REQUEST_COMPLETED',
  REQUEST_OBSOLETE = 'REQUEST_OBSOLETE',
  REQUEST_EXPIRED = 'REQUEST_EXPIRED',
  ATTEMPTS_LIMIT_REACHED = 'ATTEMPTS_LIMIT_REACHED',
  INFORMATION_NOT_MATCHED = 'Wrong patient name or date of birth',
}

export enum PAGE_TYPE {
  LOGIN = 'LOGIN',
  PATIENT_MEDICAL_RECORDS_REQUEST = 'PATIENT_MEDICAL_RECORDS_REQUEST',
  PATIENT_UPLOAD_MEDICAL_RECORDS = 'PATIENT_UPLOAD_MEDICAL_RECORDS',
  FINISH = 'FINISH',
}

export type FormValues = {
  patientFirstName: string;
  patientLastName: string;
  patientDateOfBirth: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userPhoneNumber: string;
  userComment: string;
  isRequestHaveMedicalRecords: string;
};

export enum MEDICAL_RECORDS_TYPE {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  BILLING_RECORDS = 'BILLING_RECORDS',
}

export type PatientInformation = {
  patientFirstName: undefined | string;
  patientLastName: undefined | string;
  patientDateOfBirth: undefined | string;
  requestedMedicalRecordsType: undefined | MEDICAL_RECORDS_TYPE;
  recordsRequestedDateFrom: undefined | string;
  recordsRequestedDateTo: undefined | string;
  recordsIsMaximumDateRange: undefined | boolean;
};

export type MetaData = {
  clientId: number;
  connectionId: number | undefined;
  consumerUuid: string;
  id: number;
  jiraTicketId: undefined | string;
  medicalRecordsRequestId: undefined | number;
  npi: string;
  providerDirectoryLocationId: undefined | number;
  providerNpiType: 'ORGANIZATION' | 'PRACTITIONER';
  relyingPartyId: number;
  requestType: 'FAX_FLOW';
  status: 'REQUEST_CREATED' | 'JIRA_TICKET_CREATED' | 'REQUEST_COMPLETED';
  requestDetails: {
    documentType: MEDICAL_RECORDS_TYPE | undefined;
    patientComment: string | undefined;
    dateFrom: Date | undefined;
    dateTo: Date | undefined;
    isMaximumDateRange: boolean | undefined;
  };
};

export enum COMPLETED_REQUEST_STATUSES {
  UPDATE_RECEIVED = 'UPDATE_RECEIVED',
  NO_UPDATES = 'NO_UPDATES',
}

export type MetaDataState = {
  clientId: undefined | number;
  relyingPartyId: undefined | number;
  providerName: undefined | string;
  uploadedBy: undefined | string;
  consumerUuid: undefined | string;
  userComment: undefined | string;
  documentType: undefined | MEDICAL_RECORDS_TYPE;
  orderId: undefined | number;
};

type providerType =
  | 'INDIVIDUAL'
  | 'ORGANIZATION'
  | 'EXTERNAL_INDIVIDUAL'
  | 'EXTERNAL_ORGANIZATION';

export type SupportPersonInfo = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string | undefined;
  provider_directory: {
    id: number;
    provider_type: providerType;
    npi: string | undefined;
    client_id: number;
    relying_party_id: number;
    provider_name: string | undefined;
    provider_first_name: string | undefined;
    provider_last_name: string | undefined;
    relying_party_name: string | undefined;
  };
};
